/** Custom url encoder for category URIs */
export const categoryEncode = (src: string): string => {
    return src.toLowerCase().replace(/,/g, '').replace('&', 'and').replace(/\s/g, '-');
};

export const imageUrlEncode = (fid: number | string, style?: string) => {
    return `${process.env.API_URL}/files/${fid}${style ? '? ' + style : ''}`;
};

export const imageUrlFromFid = (fid: number | string, style?: string) => {
    return `${process.env.API_URL}/files/${fid}${style ? '?style=' + style : ''}`;
};

export const imageUrlAppendStyle = (url: string, style: string) => {
    return `${url}?style=${style}`;
};



// WEBPACK FOOTER //
// ./src/contexts/link_util.ts